// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-slide-upload[data-v-fdc7a65a] {\n  margin-bottom: 20px;\n  /*/deep/*/\n}\n.editor-slide-upload .el-upload--picture-card[data-v-fdc7a65a] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
